interface segments {
  1: segment;
  2: segment;
  5: segment;
}

interface segment {
  cod: number;
  descricao: string;
}

export const segments: segments = {
  1: {
    cod: 1,
    descricao: 'Calçado',
  },
  2: {
    cod: 2,
    descricao: 'Confecção',
  },
  5: {
    cod: 5,
    descricao: 'Acessório',
  },
};
